export default [
  {
    CategoryData: "01",
    name: "Table",
    Status: "Active",
    categorylist: "Furnitures"
  },
  {
    CategoryData: "02",
    name: "Sofa",
    Status: "Inactive",
    categorylist: "Furnitures"
  },
  {
    CategoryData: "03",
    name: "Earrings",
    Status: "Active",
    categorylist: "Accessories"
  },
  {
    CategoryData: "04",
    name: "Rugs",
    Status: "Inactive",
    categorylist: "Home Décor"
  }
];
